import { DatabaseOutlined } from '@ant-design/icons';

import { Select } from '../../../components/ui';
import { useT } from '../../../i18n';
import type { NguonDangXem } from '../hooks/useNguon';

/**
 * Chọn nguồn dữ liệu, đặt ở `actions` của `PageHeader` cạnh nút Lưu: người dùng phải thấy mình đang sửa
 * nguồn nào **trước** khi bấm, vì PUT ghi đè trọn gói.
 *
 * Nguồn đã ngừng vẫn hiện (đọc được, không ghi được) kèm nhãn — giấu đi thì dữ liệu cũ biến mất mà không
 * ai hiểu vì sao. Chỉ một nguồn thì không có gì để chọn: ẩn.
 */
export function ChonNguon({ nguon }: { nguon: NguonDangXem }) {
  const { t } = useT();
  if (!nguon.dangTai && nguon.danhSach.length < 2) return null;

  return (
    <div className="flex min-w-0 items-center gap-2">
      <DatabaseOutlined className="shrink-0 text-content-muted" aria-hidden />
      <Select<string>
        aria-label={t('baoCaoDoanhNghiep.nguon.chon')}
        className="min-w-[12rem] max-w-xs"
        popupMatchSelectWidth={false}
        loading={nguon.dangTai}
        value={nguon.code}
        onChange={nguon.datNguon}
        options={nguon.danhSach.map((n) => ({
          value: n.code,
          label: n.isDefault
            ? t('baoCaoDoanhNghiep.nguon.tenMacDinh', { ten: n.name })
            : n.isActive
              ? n.name
              : t('baoCaoDoanhNghiep.nguon.tenDaNgung', { ten: n.name }),
        }))}
      />
    </div>
  );
}
